// extracted by mini-css-extract-plugin
module.exports = {"loader_spinner":"CustomLoader_loader_spinner__1_7i0"};